import { PageHero } from "../components/PageHero";
import { Reveal, SectionHeading, useDocTitle } from "../components/Reveal";
import { HoneyBookForm } from "../components/HoneyBookForm";

const STEPS = [
  ["01", "Send the inquiry", "The HoneyBook form below takes about two minutes."],
  ["02", "We reply within one business day", "With real questions, not a sales script."],
  ["03", "You get a plan and a price", "Scoped to your outcome. No obligation."],
];

export default function StartProject() {
  useDocTitle("Start a Project");

  return (
    <div data-testid="start-project-page">
      <PageHero
        eyebrow="Start a Project"
        lines={[<>Tell us what <span className="text-gold-dark">you're making.</span></>]}
        sub="Two minutes here turns into a real plan and a real price — usually within one business day."
      />

      <section className="mx-auto max-w-7xl px-4 pb-24 sm:px-8 lg:px-16">
        <div className="grid gap-8 lg:grid-cols-3">
          {STEPS.map(([num, title, copy], i) => (
            <Reveal key={num} delay={i * 0.08}>
              <div className="flex h-full gap-5 border border-ink/10 bg-white p-7">
                <p className="font-mono text-sm tracking-[0.25em] text-gold-dark">{num}</p>
                <div>
                  <h3 className="font-display text-lg font-bold text-ink">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-smoke">{copy}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div
            id="honeybook-slot"
            data-testid="honeybook-embed-slot"
            className="mx-auto mt-16 max-w-3xl border-2 border-gold/50 bg-white p-7 sm:p-10"
          >
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold-dark">Project Inquiry</p>
            <p className="mt-4 text-sm leading-relaxed text-smoke">
              Our full inquiry workflow — proposals, scheduling, and contracts — runs through
              HoneyBook. Fill out the form below and it lands directly with our team.
            </p>
            <div className="mt-6 border border-ink/10 bg-sand p-2">
              <HoneyBookForm />
            </div>
            <p className="mt-8 text-center font-mono text-[10px] uppercase tracking-[0.2em] text-ink/35">
              Prefer email?{" "}
              <a href="mailto:Alan@studiosolutionsfdl.com" data-testid="sp-email-link" className="text-gold-dark underline underline-offset-4">
                Alan@studiosolutionsfdl.com
              </a>
            </p>
          </div>
        </Reveal>

        <Reveal>
          <div className="mt-16 border-t border-ink/10 pt-10">
            <SectionHeading
              eyebrow="What Happens Next"
              title={<>No pressure. <span className="text-gold-dark">Ever.</span></>}
              sub="If we're the right fit, you'll know within one conversation. If we're not, we'll point you to someone who is."
            />
          </div>
        </Reveal>
      </section>
    </div>
  );
}
